/**
 * Share Module - Handles social sharing and link copying
 */

/**
 * Setup event listeners for social sharing and link copying functionality.
 * @returns {void}
 */
export function setupShare() {
  const shareBar = document.getElementById('shareBar');
  const copyBtn = document.getElementById('copyUrlBtn');
  
  if (!shareBar) return;

  const buttons = shareBar.querySelectorAll('.share-bar__btn[data-platform]');
  
  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const platform = btn.getAttribute('data-platform');
      const url = encodeURIComponent(window.location.href);
      const title = encodeURIComponent(document.title);
      let shareUrl = '';

      switch (platform) {
        case 'whatsapp':
          shareUrl = `https://wa.me/?text=${title}%20${url}`;
          break;
        case 'facebook':
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
          break;
        case 'twitter':
          shareUrl = `https://twitter.com/intent/tweet?text=${title}&url=${url}`;
          break;
      }

      if (shareUrl) {
        window.open(shareUrl, '_blank', 'noopener,noreferrer');
      }
    });
  });

  if (copyBtn) {
    copyBtn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        
        // Visual feedback
        const icon = copyBtn.querySelector('i');
        const originalClass = icon.className;
        icon.className = 'fas fa-check';
        copyBtn.classList.add('share-bar__btn--success');
        
        setTimeout(() => {
          icon.className = originalClass;
          copyBtn.classList.remove('share-bar__btn--success');
        }, 2000);
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    });
  }
}
